import * as React from 'react'

import {
  GroupHeader,
  GroupHeaderTrigger,
} from '~/client/src/shared/components/GroupHeader'
import { Checkbox } from '~/client/src/shared/components/shadcn-ui/checkbox'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { cn } from '~/client/src/shared/utils/cn'

import type { TableBandPresentation } from './DesktopListTable'

const WIDTH_CLASS_NAME = {
  fit: 'tw:w-fit',
  full: 'tw:w-full',
} as const

interface IListBandHeaderProps {
  readonly band: TableBandPresentation
  readonly width?: keyof typeof WIDTH_CLASS_NAME
}

export default function ListBandHeader({
  band,
  width = 'fit',
}: IListBandHeaderProps): React.ReactElement {
  return (
    <GroupHeader
      className={cn(
        'tw:sticky tw:left-0 tw:z-[1] tw:max-w-full tw:border-b-0',
        WIDTH_CLASS_NAME[width],
        // Row checkbox: centred in the 44px column's 43px padding box (1px border-r) → (43 - 16) / 2.
        band.selectable && 'tw:pl-[13.5px]',
      )}
    >
      {band.selectable && (
        <Checkbox
          checked={band.selected}
          indeterminate={band.indeterminate}
          onCheckedChange={() => band.onToggleSelection()}
          aria-label={Localization.translator.select}
        />
      )}

      <GroupHeaderTrigger
        expanded={band.expanded}
        onClick={band.onToggleExpand}
        ariaLabel={band.label}
        label={band.label}
        count={band.count}
      />
    </GroupHeader>
  )
}
